import { ticketListQuerySchema, type TicketListQuery } from '@gb-ticket/shared-types';

import { toSearchParams } from '@/lib/format';

export const EMPTY_TICKET_LIST_QUERY: TicketListQuery = {
  page: 1,
  pageSize: 25,
  sortBy: 'updatedAt',
  sortOrder: 'desc',
};

const SEARCH_KEYS = [
  'page',
  'pageSize',
  'sortBy',
  'sortOrder',
  'q',
  'status',
  'priority',
  'type',
  'categoryId',
  'queueId',
  'assigneeId',
  'unassigned',
  'createdFrom',
  'createdTo',
  'isMajor',
  'problemLifecycle',
  'changeWindow',
  'changeRisk',
  'changeApproval',
  'slaRisk',
] as const;

export function isTicketListPath(pathname: string): boolean {
  return pathname === '/helpdesk/tickets' || pathname === '/portal/tickets';
}

export function ticketListPath(query: Partial<TicketListQuery>): string {
  const merged: TicketListQuery = {
    ...EMPTY_TICKET_LIST_QUERY,
    ...query,
    page: 1,
    pageSize: query.pageSize ?? EMPTY_TICKET_LIST_QUERY.pageSize,
  };
  return `/helpdesk/tickets${toSearchParams({
    page: merged.page,
    pageSize: merged.pageSize,
    sortBy: merged.sortBy,
    sortOrder: merged.sortOrder,
    q: merged.q,
    status: merged.status,
    priority: merged.priority,
    type: merged.type,
    categoryId: merged.categoryId,
    queueId: merged.queueId,
    assigneeId: merged.assigneeId,
    unassigned: merged.unassigned,
    createdFrom: merged.createdFrom,
    createdTo: merged.createdTo,
    isMajor: merged.isMajor,
    problemLifecycle: merged.problemLifecycle,
    changeWindow: merged.changeWindow,
    changeRisk: merged.changeRisk,
    changeApproval: merged.changeApproval,
    slaRisk: merged.slaRisk,
  })}`;
}

export function ticketListQueryFromSearch(search: string): TicketListQuery | null {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  if ([...params.keys()].length === 0) {
    return null;
  }
  const raw: Record<string, unknown> = { ...EMPTY_TICKET_LIST_QUERY };
  for (const key of SEARCH_KEYS) {
    const all = params.getAll(key);
    if (all.length === 0) {
      continue;
    }
    raw[key] = all.length > 1 ? all : all[0];
  }
  const parsed = ticketListQuerySchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
